.treemap-chart {
  display: grid;
  place-self: center;
  width: 100%;
  min-height: 340px;
  max-height: 600px;
  aspect-ratio: 1.5;
  padding: var(--mantine-spacing-sm);

  > * {
    width: 100%;
    height: 100%;
  }

  :fullscreen & {
    place-self: stretch;
    max-height: none;
    aspect-ratio: auto;

    > * {
      height: 100%;
    }
  }
}

.tile {
  transition: fill-opacity 120ms ease;

  &:hover {
    fill-opacity: 0.85;
  }
}

.label {
  font-size: var(--mantine-font-size-xs);
  font-weight: 600;
  pointer-events: none;
  fill: var(--mantine-color-dark-9);
  stroke-width: 0;
}

.value {
  font-size: var(--mantine-font-size-xs);
  pointer-events: none;
  opacity: 0.85;
  fill: var(--mantine-color-dark-9);
  stroke-width: 0;
}
